import { render, staticRenderFns } from "./RequisicoesComErroCarrosselCard.vue?vue&type=template&id=5455f4b0&scoped=true"
import script from "./RequisicoesComErroCarrosselCard.vue?vue&type=script&lang=js"
export * from "./RequisicoesComErroCarrosselCard.vue?vue&type=script&lang=js"
import style0 from "./RequisicoesComErroCarrosselCard.vue?vue&type=style&index=0&id=5455f4b0&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5455f4b0",
  null
  
)

export default component.exports